import AppRoutes from "./routes/AppRoutes";
import SessionManager from "./components/common/SessionManager";

function App() {
  return (
    <>
      <SessionManager />
      <AppRoutes />
    </>
  );
}

export default App;
